/**
 * Regional Hub config — one entry per multi-city SEO region.
 *
 * Each region surfaces top pros across several cities on a single page,
 * cross-links to the per-city /pros/{city} directories, and targets the
 * specific NRI diaspora most likely to search for that region.
 */
export const REGIONS = {
  punjab: {
    slug: 'punjab',
    name: 'Punjab & Chandigarh',
    country: 'IN',
    h1: 'Punjab property professionals — for NRIs in UK & Canada',
    sub:
      'Verified estate agents, conveyancing solicitors and mortgage brokers across the Chandigarh-Mohali-Tricity belt and Punjab\'s top cities. Independent listings with real Google ratings — built for NRIs investing back home.',
    cities: ['Chandigarh', 'Mohali', 'Ludhiana', 'Amritsar', 'Jalandhar', 'Patiala'],
    audience_blurb:
      'The Punjab–UK and Punjab–Canada corridors account for one of the largest NRI property flows globally. Most enquiries come from Birmingham, Southall, Leicester, Toronto and Brampton — and every pro below is sourced from local Google reviews so you don\'t fly blind.',
    faqs: [
      {
        q: 'Why a separate Punjab hub?',
        a: 'Punjab cities share a single property-law regime (the Punjab Apartment Ownership Act, Stamp Duty rules, and PUDA approvals) — so a solicitor familiar with one Punjab city handles the rest fluently. Grouping them in one hub mirrors how NRI buyers actually shop.',
      },
      {
        q: 'Do you cover Chandigarh separately?',
        a: 'Chandigarh is a Union Territory but commonly grouped with Punjab for property purposes (most Mohali/Panchkula investors browse Chandigarh too). We include it here plus on its own /pros/chandigarh page.',
      },
      {
        q: 'How are the connection fees priced for NRIs?',
        a: 'You pay in whichever currency your card is in. ₹1,535 INR · £15.52 GBP · C$30 CAD per pro unlocked. Same NET price (₹1,499 / £15 / C$25) — Stripe handles the FX.',
      },
      {
        q: 'Can the same solicitor handle FEMA + PAN-related steps?',
        a: 'Yes — every solicitor in our Punjab directory has been screened for NRI/OCI familiarity and we email a warm-intro on your behalf before they call.',
      },
    ],
  },
  'london-greater': {
    slug: 'london-greater',
    name: 'Greater London',
    country: 'UK',
    h1: 'London property professionals — agents, solicitors & brokers',
    sub:
      'Verified estate agents, conveyancing solicitors and mortgage brokers across Greater London. Independent listings with real Google ratings — no agency referral markups.',
    cities: ['London'],
    audience_blurb:
      'London buyers and sellers using Shopperden bypass the agency-to-agency commission chain. The pros below are sourced from local Google reviews and you pay one flat £15.52 connection fee.',
    faqs: [
      { q: 'Are these pros regulated?', a: 'Solicitors listed must be SRA-regulated to claim their profile. Brokers must be FCA-authorised. Estate agents need TPO/PRS membership.' },
      { q: 'Why so many agents per page?', a: 'Greater London has 32 boroughs — we surface the top-rated estate agents across all of them on one page so you can pick locally.' },
      { q: 'Do you cover lettings?', a: 'Yes — letting agents and conveyancers for AST tenancies are both in the directory.' },
    ],
  },
  ontario: {
    slug: 'ontario',
    name: 'Ontario',
    country: 'CA',
    h1: 'Ontario property professionals — for buyers in Toronto, Mississauga & Brampton',
    sub:
      'Verified Realtors, conveyancing solicitors and mortgage brokers across Ontario. Real Google ratings — built for the South Asian and NRI buyer corridors into the GTA.',
    cities: ['Toronto', 'Mississauga', 'Brampton'],
    audience_blurb:
      'The GTA has the highest per-capita Punjabi and Gujarati diaspora in Canada. The pros below cover Real Estate Council of Ontario (RECO) and Law Society of Ontario (LSO) standards.',
    faqs: [
      { q: 'Are these Realtors RECO registered?', a: 'Yes — to claim a profile every Ontario Realtor must show RECO registration. Solicitors must be LSO-licensed.' },
      { q: 'What about new-build pre-construction projects?', a: 'Several of the Toronto/Mississauga agents specialise in pre-con — filter by their bio after unlocking contact.' },
      { q: 'How do GST/HST rebates work?', a: 'Ask your conveyancing solicitor before signing — they handle Ontario Land Transfer Tax and HST rebate filings.' },
    ],
  },
};

export const ALL_REGION_SLUGS = Object.keys(REGIONS);
